import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { CHARGE_PORT } from 'site-modules/shared/constants/ev-insights';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

export function TimeToCharge({ chargeTime = null, portType = null, isPreview = false }) {
  const chargePort = CHARGE_PORT[portType];

  return (
    <div className="time-to-charge">
      <div className={classnames({ 'heading-4 text-center mb-0_25': chargeTime, 'mb-1_5': !chargeTime && chargePort })}>
        {chargeTime ? <Fragment>{chargeTime} hours</Fragment> : 'No charging time information available'}
      </div>
      {!!chargeTime && (
        <Fragment>
          <div className="medium text-center mb-1">Total Charging Time (240V outlet)</div>
          <div className={classnames('medium', { 'mb-1_5': chargePort })}>
            EV batteries should be kept at 30-80% charged to extend battery life.
          </div>
        </Fragment>
      )}
      {!isPreview && !!chargePort && (
        <div className="bg-cool-gray-100 py-1 px-1 text-center radius-10">
          <div className="fw-bold text-cool-gray-30 mb-0_25">
            {portType}
            <PopoverItem iconClassName="medium" screenReaderTooltipLabel={`${portType} port`}>
              {chargePort.description}
            </PopoverItem>
          </div>
          <div className="mb-1">Plug Type</div>
          <img src={getStaticImageUrl(chargePort.image)} alt="" height={117} />
        </div>
      )}
    </div>
  );
}

TimeToCharge.propTypes = {
  chargeTime: PropTypes.number,
  portType: PropTypes.string,
  isPreview: PropTypes.bool,
};
